import { useEffect, useState } from 'react'
import { useContext } from "react";
import { ContextApp } from "./context/ContextApp"

import './App.css';

import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Navbar from './components/navbar/Navbar';

import Router from './routes/Router';
import Login from './pages/login/Login';


const App = () => {

  const { token, refreshToken } = useContext(ContextApp);
  const [logeado, setLogeado] = useState(false)


  useEffect(() => {
    document.body.setAttribute('data-theme', localStorage.getItem('theme'));

    const loadData = async () => {
        await refreshToken()
        token.value !== '' ? setLogeado(true) : setLogeado(false)
    }
    loadData()
  }, [token, refreshToken]);


  return (
    <div className='App'>
      <Header />
      {logeado
        ?
        <>
          <Navbar />
          <Router />
        </>
        : <Login setLogeado={setLogeado}/>
      }
      <Footer />
    </div>

  );
}

export default App;
